export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10592.5d7cbe82.jpg";